import { initializeAllLocationLists } from './location-list';
import {onDomReady} from "../../../shared/ts/helpers/on-dom-ready";

function init() {
  initializeAllLocationLists((callback, selectElement) => {
    selectElement.addEventListener('change', callback);
  });
}

onDomReady(init);
